import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import About from "./components/pages/About/About";
import Home from "./components/pages/Home/Home";
import Calculate from "./components/pages/Calculate/Calculate";
import Cameras from "./components/pages/Cameras/Cameras";
import Yungstar from "./components/pages/Yungstar/Yungstar";
import Privacy from "./components/pages/Privacy/Privacy";
import Cookies from "./components/pages/Cookies/Cookies";

export const AppRoutes = () => {
  return (
    <Router>
      {/* <Navbar isVisible={true} /> */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/calculate" element={<Calculate />} />
        <Route path="/cameras" element={<Cameras />} />
        <Route path="/yungstar" element={<Yungstar />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/cookies" element={<Cookies />} />
      </Routes>
      {/* <Footer alwaysVisible={true} /> */}
    </Router>
  );
};